import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import findIdNot from "../../styles/images/img_findId_not.png";
import findId from "../../styles/images/img_findId.png";
import OnePageLayout from "../../components/layout/OnePageLayout";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";

const FindIdResult = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const userId = location.state !== null ? location.state.userId : "";
  const result = location.state !== null ? location.state.result : "";
  // console.log("result", location.state);
  return (
    <OnlyHeaderLayout title="아이디 찾기">
      <Section>
        {userId ? (
          <>
            <Content>
              <TextDiv>
                <h3>
                  고객님의 아이디는
                  <br />
                  <span className="col">{userId} </span>입니다.
                </h3>
              </TextDiv>
              <StyledImgWrap margintop="7.631">
                <img src={findId} alt="" />
              </StyledImgWrap>
            </Content>
            <Btns>
              <ButtonL
                onClick={() => {
                  navigate("/login");
                }}
              >
                로그인 하러 가기
              </ButtonL>
            </Btns>
          </>
        ) : (
          <>
            <Content>
              <TextDiv>
                <h3>
                  일치하는 아이디가 없습니다.
                  <br />
                  다시 한번 확인해주세요.
                </h3>
              </TextDiv>
              <StyledImgWrap imgwidth="20" margintop="7.359">
                <img src={findIdNot} alt="" />
              </StyledImgWrap>
            </Content>
            <Btns>
              <ButtonL
                onClick={() => {
                  navigate("/login");
                }}
              >
                이전페이지 가기
              </ButtonL>
            </Btns>
          </>
        )}
      </Section>
    </OnlyHeaderLayout>
  );
};

export default FindIdResult;

const StyledImgWrap = styled(ImgWrap)`
  img {
    width: 20rem;
  }
`;
